import React from 'react'

import Base from '../_Base'

const AuM = (props) => (
  <Base width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path
      d="M24.0249 21.9975C24.0249 23.0983 23.123 24 22.0263 24H2.02349C0.922574 24 0.0249023 23.0983 0.0249023 21.9975V1.99824C0.0249023 0.897513 0.922574 0 2.02349 0H22.0263C23.1272 0 24.0249 0.897513 24.0249 1.99824V21.9975Z"
      fill="white"
    />
    <path
      d="M22.9319 21.0902C22.9319 22.0908 22.1121 22.9106 21.1154 22.9106H2.93447C1.93383 22.9106 1.11792 22.0908 1.11792 21.0902V2.90932C1.11792 1.90868 1.93383 1.09277 2.93447 1.09277H21.1154C22.116 1.09277 22.9319 1.90868 22.9319 2.90932V21.0902Z"
      fill="#00AEEF"
    />
    <path
      d="M13.9955 15.8874V11.4307L12.533 14.3288H11.5247L10.0506 11.4307V15.8874H8.55737V8.24023H10.0275L12.025 12.3737L14.0109 8.24023H15.4849V15.8874H13.9916H13.9955Z"
      fill="white"
    />
    <path
      d="M5.70557 12.0002C5.70557 15.487 8.53815 18.3196 12.025 18.3196C15.5119 18.3196 18.3444 15.487 18.3444 12.0002C18.3444 8.51331 15.508 5.68457 12.025 5.68457C8.542 5.68457 5.70557 8.51715 5.70557 12.0002ZM6.20204 12.0002C6.20204 8.79041 8.81525 6.17719 12.025 6.17719C15.2348 6.17719 17.848 8.79041 17.848 12.0002C17.848 15.2099 15.2348 17.8231 12.025 17.8231C8.81525 17.8231 6.20204 15.2099 6.20204 12.0002Z"
      fill="white"
    />
  </Base>
)

export default AuM
